import { render } from "./OrderModalFooter.vue?vue&type=template&id=145f7354"
import script from "./OrderModalFooter.vue?vue&type=script&lang=js"
export * from "./OrderModalFooter.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_955269ba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__